// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1Gw2L","loaderOuter":"PageOverlayLoader_loaderOuter__3QYRr"};